import {create} from "zustand";

export const useAppInstallModal = create((set) => ({
    isOpen: false,
    text: null,
    source: null,
    openModal: (text, source = null) => set({ isOpen: true, text, source }),
    closeModal: () => set({ isOpen: false, text: null, source: null }),
}));
